import v from 'validator';
import i18next from 'i18next';

const nameMin = 3;
const nameMax = 16;
const passwordMin = 6;
const passwordMax = 16;

class ValidationService {    
    static isRequired(param) {
        if (!param) {
            return i18next.t('error.required');
        }
        return null;
    }

    static isEmail(param, isRequired) {
        if (isRequired && !param) {
            return i18next.t('error.required');
        }
        if (!isRequired && !param) {
            return null;
        }
        if (!v.isEmail(String(param))) {
            return i18next.t('error.email');
        }

        return null;
    }

    static isName(param, isRequired) {
        if (isRequired && !param) {
            return i18next.t('error.required');
        }
        if (!isRequired && !param) {
            return null;
        }
        if (v.matches(String(param), /[`~!@#$%^&*()=+|{}/[];:'",<.>?]/)) {
            return i18next.t('error.forbiddenSymbols');
        }
        if (!v.isLength(String(param), {min: nameMin, max: nameMax})) {
            return i18next.t('error.minMax', {min: nameMin, max: nameMax});
        }

        return null;
    }

    static isUserName(param, isRequired) {
        if (isRequired && !param) {
            return i18next.t('error.required');
        }
        if (!isRequired && !param) {
            return null;
        }
        if (v.matches(String(param), /[`~!@#$%^&*()\-\=+|{}\/[\];:'",<.>? ]/)) {
            return i18next.t('error.forbiddenSymbols');
        }
        if (!v.isLength(String(param), {min: 2, max: nameMax})) {
            return i18next.t('error.minMax', {min: nameMin, max: nameMax});
        }
        
        return null;
    }

    static isPassword(param, paramName, isRequired) {
        if (isRequired && !param) {
            return i18next.t(`error.${paramName || 'required'}`);
        }
        if (!isRequired && !param) {
            return null;
        }
        if (v.matches(String(param), /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])+$/)) {
            return i18next.t('error.forbiddenSymbols');
        }
        if (!v.isLength(String(param), {min: passwordMin, max: passwordMax}) || 
            !v.matches(String(param), /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/)
        ) {
            return i18next.t('error.format');
        }
        return null;
    }

    static isNumeric(param, isRequired) {
        if (isRequired && !param) {
            return i18next.t('error.required');
        }
        if (!isRequired && !param) {
            return null;
        }
        if (!v.isNumeric(String(param))) {
            return i18next.t('error.numeric');
        }

        return null;
    }

    static isAmount(param, isRequired) {
        if (isRequired && !param) {
            return i18next.t('error.required');
        }
        if (!isRequired && !param) {
            return null;
        }
        let amount = String(param).split('.');
        if (!v.isFloat(String(param), {min: 0.00, max: 100000.00}) || (amount[1] && amount[1].length > 2)) {
            return i18next.t('error.amount');
        }

        return null;
    }
};

export default ValidationService;
